import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
//import Cache from 'i18next-localstorage-cache';

import Backend from 'i18next-xhr-backend';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init


i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    .use(LanguageDetector)
    //.use(Cache)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'uk',
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        //detection: {
        //    order: ['cookie'],
        //    lookupCookie: '.AspNetCore.Culture',
        //    caches: ['cookie'],
        //}
    });


export default i18n;